
// Meta-data
export const META_GET_ALL  = 'OrganizationService/api/meta-data/get-all';
export const META_UPDATE  = 'OrganizationService/api/meta-data/update';

export const GET_ALL_BREAK_DEFINITIONS = 'TimeManagementService/api/break-definition/get-all'
export const SEARCH_BREAK_DEFINITIONS = 'TimeManagementService/api/break-definition/search';
export const GET_BREAK_DEFINITION_BY_ID = 'TimeManagementService/api/break-definition/get'; // append /{id} dynamically
export const CREATE_BREAK_DEFINITION = 'TimeManagementService/api/break-definition/create';
export const UPDATE_BREAK_DEFINITION = 'TimeManagementService/api/break-definition/update'; // append /{id} dynamically
export const DELETE_BREAK_DEFINITION = 'TimeManagementService/api/break-definition/delete'; // append /{id} dynamically
export const BULK_DELETE_BREAK_DEFINITION = 'TimeManagementService/api/break-definition/bulk-delete';